import { Map } from 'immutable';
import { SAVE_FILTERS_FOR_CANCEL } from '../constants/filters';

const getInitialState = () => Map({ lastAppliedFilters: {} });

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case SAVE_FILTERS_FOR_CANCEL:
      return state.set('lastAppliedFilters', action.payload);
    default:
      return state;
  }
}
